import { type SanityDocument } from '@sanity/client'

import { AffirmationType } from 'App/AffirmationsApp/AffirmationData'

import { sanityClient } from './sanityClient'

const CACHE_TTL_MS: number = 60_000 * 5 // Cache IDs for 5 minutes

let cachedIds: string[] | null = null
let typeCache: string | null = null
let cacheTimestamp = 0

export default async function getRandomAffirmations(count: number, types: AffirmationType[]) {
  if (
    cachedIds === null ||
    typeCache !== types.toString() ||
    Date.now() - cacheTimestamp > CACHE_TTL_MS
  ) {
    cachedIds = await sanityClient.fetch<string[]>(IDS_QUERY, { types })
    typeCache = types.toString()
    cacheTimestamp = Date.now()
  }
  const randomIds = pickRandom(cachedIds, count)
  return await sanityClient.fetch<SanityDocument[]>(QUERY, { ids: randomIds })
}

function pickRandom<T>(arr: T[], count: number): T[] {
  const copy = arr.slice()
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[copy[i], copy[j]] = [copy[j], copy[i]]
  }
  return copy.slice(0, count)
}

const IDS_QUERY = `*[_type == "affirmation" && type in $types && !(_id in path("drafts.**"))]._id`
const QUERY = `*[_id in $ids]{ _id, text }`
